import React from 'react';
import {View, StyleSheet, Text } from '@react-pdf/renderer';
import { displayDate } from '@iso/lib/helpers/utility';

const styles = StyleSheet.create({
    reportText:{
        marginTop: 15,
        marginBottom: 5,
        color: '#000',
        letterSpacing: 1,
        fontSize: 11
    },
    contentTime:{
        width: '700px',
        display:'flex',
        flexDirection: 'row'
    },
    text:{
        width: '35px',
    },
    reportTextUnderscore:{
        width: '60px',
        color: '#000',
        fontSize: 9,
        height: '14px',
        textIndent: '2px',
        marginTop: '-1px',
        marginRight: '5px',
        borderBottom: '1px #000 solid',
        paddingBottom:'-2px'
    },
});

const defaultData = {'date':'', 'start':'', 'end':'', 'total':''};

const myDisplayDate = (t) => {
    return (typeof  t === 'undefined' || t.length === 0) ? <Text style={{textIndent:'15px'}}>/      /</Text> : <Text style={{textIndent:'5px', letterSpacing: 1,}}>{displayDate(t)}</Text>;
};

const myDisplayTime = (t) => {
    return (typeof  t === 'undefined' || t.length === 0) ? <Text style={{textIndent:'25px'}}>:</Text> : <Text style={{textIndent:'15px'}}>{t}</Text>;
};

let timeTotal = '';

const generateData = (data) => {
    let ret = [];
    
    let totalHoras = 0;
    let totalMinutos = 0;

    for (let index = 0; index < 15; index++) {
        const element = (typeof data[index] !== 'undefined') ? data[index] : defaultData;
        // timeTotal += (element.total.length !== 0) ? parseInt(element.total) : 0;

        if(element.total && element.total.length !== 0) {
            const [horas, minutos] = element.total.split(':');
            totalHoras += parseInt(horas, 10);
            totalMinutos += parseInt(minutos, 10);
        } else {
            element.total = '';
            element.end = '';
            element.realizedBy = {name:''};
        }

        ret.push(
            <View style={styles.contentTime}>
                <Text style={{width: '30px'}}>Data:</Text>
                <Text style={styles.reportTextUnderscore}>{myDisplayDate(element.date)}</Text>
                <Text style={styles.text}>Início:</Text>
                <Text style={{...styles.reportTextUnderscore, width: '50px'}}>{myDisplayTime(element.start)}</Text>
                <Text style={{width: '25px'}}>Fim:</Text>
                <Text style={{...styles.reportTextUnderscore, width: '50px'}}>{myDisplayTime(element.end)}</Text>
                <Text style={{...styles.text, width:'80px'}}>Total em horas:</Text>
                <Text style={{...styles.reportTextUnderscore, width: '50px'}}>{element.total}</Text>
                <Text style={{...styles.text, width:'50px'}}>Fornecedor:</Text>
                <Text style={{...styles.reportTextUnderscore, width: '85px'}}>{element.realizedBy.name}</Text>
            </View>
        )
    }

    if(totalMinutos > 0 || totalHoras > 0) {
        totalHoras += Math.floor(totalMinutos / 60);
        totalMinutos = totalMinutos % 60;
        timeTotal = `${totalHoras.toString().padStart(2, '0')}:${totalMinutos.toString().padStart(2, '0')}h`
    }

    return ret;
}

const OrderServiceTimeControl = ({data}) => {
    const dados = ((data.orderService && data.orderService?.timeControl.length > 0)) ? data.orderService?.timeControl : []
    return <>
        <Text style={styles.reportText}>CONTROLE DE TEMPO</Text>
        { generateData(dados) }
        <View style={{...styles.contentTime, marginTop:'5px'}}>
            <Text style={{...styles.reportText, marginTop:'0px', textAlign:'right', width:'482px'}}>Soma total (horas): </Text>
            <Text style={{...styles.reportTextUnderscore, width:'50px', marginLeft: '3px'}}>{timeTotal}</Text>
        </View>
    </>

};

export default OrderServiceTimeControl